import { render, staticRenderFns } from "./EeiregList.vue?vue&type=template&id=b63778b2&"
import script from "./EeiregList.js?vue&type=script&lang=js&"
export * from "./EeiregList.js?vue&type=script&lang=js&"
import style0 from "./EeiregList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports